/**
 * Where the Surprise & Delight free gift renders within an order items list.
 *
 * Single source of truth across the cart, checkout order summary and order
 * confirmation on both web and mobile — every surface composes its display
 * list through `withFreeGiftOrderItem`, so changing this constant moves the
 * gift everywhere at once. The gift renders at the bottom (last item) of the
 * order items list.
 */
const FREE_GIFT_LIST_POSITION = 'bottom';

/**
 * Compose the display list for an order items list, inserting the synthetic
 * S&D free gift item (built by the platform `useFreeGiftOrderItem` hooks) at
 * the canonical position. Returns the order items untouched when no gift is
 * selected (`freeGiftItem` is null/undefined).
 */
const withFreeGiftOrderItem = (orderItems, freeGiftItem) => {
  const items = orderItems && typeof orderItems.slice === 'function' ? orderItems.slice() : orderItems || [];
  if (!freeGiftItem) {
    return items;
  }
  return FREE_GIFT_LIST_POSITION === 'top' ? [freeGiftItem, ...items] : [...items, freeGiftItem];
};

export { FREE_GIFT_LIST_POSITION, withFreeGiftOrderItem };
